export enum Menu {
    DASHBOARD = 'DASHBOARD',
    CONTA_PAGAR = 'CONTA_PAGAR',
    CONTA_RECEBER = 'CONTA_RECEBER',
    PERFIL = 'PERFIL',
    USUARIO = 'USUARIO',
    CLIENTE = 'CLIENTE',
    FORNECEDOR = 'FORNECEDOR',
    PLANO = 'PLANO',
    FUNCIONALIDADE = 'FUNCIONALIDADE',
    TICKET = 'TICKET',
    SEGMENTO = 'SEGMENTO',
    BANNER = 'BANNER',
    DEPARTAMENTO = 'DEPARTAMENTO',
    CARGO = 'CARGO',
    COLABORADOR = 'COLABORADOR',
    RELATORIO_CONTA_RECEBER = 'RELATORIO_CONTA_RECEBER',
    RELATORIO_CONTA_PAGAR = 'RELATORIO_CONTA_PAGAR',
    RELATORIO_TICKET = 'RELATORIO_TICKET',
    RELATORIO_CLIENTE = 'RELATORIO_CLIENTE',
}

export const MenuInfo: { [key in Menu]: { nome: string } } = {
    [Menu.DASHBOARD]: { nome: "Dashboard" },
    [Menu.CONTA_PAGAR]: { nome: "Conta a Pagar" },
    [Menu.CONTA_RECEBER]: { nome: "Conta a Receber" },
    [Menu.PERFIL]: { nome: "Perfil" },
    [Menu.USUARIO]: { nome: "Usuário" },
    [Menu.CLIENTE]: { nome: "Cliente" },
    [Menu.FORNECEDOR]: { nome: "Fornecedor" },
    [Menu.PLANO]: { nome: "Plano" },
    [Menu.FUNCIONALIDADE]: { nome: "Funcionalidade" },
    [Menu.TICKET]: { nome: "Ticket" },
    [Menu.SEGMENTO]: { nome: "Segmento" },
    [Menu.BANNER]: { nome: "Banner" },
    [Menu.DEPARTAMENTO]: { nome: "Departamento" },
    [Menu.CARGO]: { nome: "Cargo" },
    [Menu.COLABORADOR]: { nome: "Colaborador" },
    [Menu.RELATORIO_CONTA_RECEBER]: { nome: "Relatório Contas a Receber" },
    [Menu.RELATORIO_CONTA_PAGAR]: { nome: "Relatório Contas a Pagar" },
    [Menu.RELATORIO_TICKET]: { nome: "Relatório Tickets" },
    [Menu.RELATORIO_CLIENTE]: { nome: "Relatório Clientes" },
};